<div class="popup marginBottomStyle" 
    style="position: relative; overflow: scroll; height: 100%;overflow-x: hidden;">

    <div class="row topRowMargins headerStyle" style="margin-top: 0;">
      <div  style="margin-left: 15px;">
        <label class="textColour">Attribute Mapping</label>
      </div>
    </div>
 <div class="container" style="margin: 0;padding: 0;" >

    <form novalidate [formGroup]="validations_form">
          <div class="row">
            <div class="col-lg-6">
            <mat-form-field appearance="outline" class="mapped-object-field">
            <mat-label>Select Mapped Objects</mat-label>

            <mat-select
              panelClass="mapped-object-panel"
              (selectionChange)="onObjectSelectionChange($event)"
              [(ngModel)]="selectedObjects"
              formControlName="objects"
              ngDefaultControl
              required>

              <mat-option disabled class="mapped-header">
                <div class="mapped-row">
                  <span>Source</span>
                  <span class="dash">-</span>
                  <span>Target</span>
                </div>
              </mat-option>

              <mat-option
                *ngFor="let data of mappingConfigurationData"
                [value]="data.mappingconfigurationid"
                class="mapped-option">

                <div class="mapped-row">
                  <span class="cell-text">{{ data.stageobjectlabel }}</span>
                  <span class="dash">-</span>
                  <span class="cell-text">{{ data.targetobjectlabel }}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
          </div>
          </div>
           <div class="row">
           <div class="col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Stage / Source Attributes</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedSourceAttributeListNames" (click)="searchableStageSourceObjects()"
                    formControlName="selectStageSourceObjectsForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectStageSourceObjectsForm">
                      <span
                        *ngIf="validations_form.get('selectStageSourceObjectsForm').hasError(validation.type) && (validations_form.get('selectStageSourceObjectsForm').dirty || validations_form.get('selectStageSourceObjectsForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Target Attributes</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedTargetAttribute" (click)="searchableTargetObjects()"
                    formControlName="selectTargetAttributeForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectTargetAttributeForm">
                      <span
                        *ngIf="validations_form.get('selectTargetAttributeForm').hasError(validation.type) && (validations_form.get('selectTargetAttributeForm').dirty || validations_form.get('selectTargetAttributeForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3">
    <mat-form-field class="filter" appearance="outline">
      <mat-label i18n="@@targetloginusername">
        Mapping Type
      </mat-label>
      <mat-select formControlName="mappingType" [(ngModel)]="mappingType" (selectionChange)="onMappingTypeChange($event)">
              <!-- <mat-option *ngFor="let tempObject of mappingTypeData" [value]="tempObject.name">
                  {{tempObject.label}}
              </mat-option> -->
              <mat-option *ngFor="let tempObject of mappingTypeDataDropDown" [value]="tempObject.lookupcode">
                  {{tempObject.lookupvalue}}
              </mat-option>

      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.mappingType">
        <span
          *ngIf="validations_form.get('mappingType').hasError(validation.type) && (validations_form.get('mappingType').dirty || validations_form.get('mappingType').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
  </mat-form-field>
      </div>
      <div class="col-lg-3" > 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Codelist Name</mat-label>
          <input
              type="text"
              matInput
              [(ngModel)]="codelistName"
              formControlName="codelistname"
              placeholder="CodeList Name"
               (click)="searchableCodeListName()"
              readonly
            />
          <!-- <mat-select
                matNativeControl
                [(ngModel)]="codelistName"
                formControlName="codelistname"
              >
                <span  *ngFor="let data of codeListData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.mappingTypeName"
                >
                {{ data.mappingTypeName }}
                </mat-option>
                </span>
               
              </mat-select>  -->
            <!-- <input matInput formControlName="codelistname" [(ngModel)]="codelistName" type="text" placeholder="Codelist Name" > -->
            <mat-error *ngFor="let validation of validation_messages.codelistname">
              <span
                  *ngIf="validations_form.get('codelistname').hasError(validation.type) && (validations_form.get('codelistname').dirty || validations_form.get('codelistname').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
           <div class="col-lg-3" *ngIf="mappingType == 'Codelist Mapping' || mappingType == 'Lookup Mapping'">
    <mat-form-field class="filter" appearance="outline">
      <mat-label i18n="@@targetloginusername">
        Default
      </mat-label>
      <mat-select formControlName="codelistValueType" [(ngModel)]="codelistValueType" (selectionChange)="onCodelistDefalutValueTypeChange()">
              <!-- <mat-option value="Source">
                  Source
              </mat-option>
              <mat-option value="Null">
                  Null
              </mat-option> -->
              <!-- <mat-option value="Query">
                  Query
              </mat-option> -->
              <!-- <mat-option value="Constant">
                  Constant
              </mat-option> -->
                <mat-option *ngFor="let tempObject of defult" [value]="tempObject.lookupcode">
                  {{tempObject.lookupvalue}}
              </mat-option>
      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.codelistValueType">
        <span
          *ngIf="validations_form.get('codelistValueType').hasError(validation.type) && (validations_form.get('codelistValueType').dirty || validations_form.get('codelistValueType').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
  </mat-form-field>
      </div>
       <div class="col-lg-3" *ngIf="(mappingType == 'Codelist Mapping' || mappingType == 'Lookup Mapping') && codelistValueType == 'Constant'">
            <mat-form-field appearance="outline">
                <mat-label i18n="@@TMshoppingcomplexchooseimage">Query</mat-label>
                <textarea matInput style="height: 20px;" class="file-path validate" placeholder="Query" formControlName="codelistValueTypeQuery" [(ngModel)]="codelistValueTypeQuery" ></textarea>
                  <mat-error *ngFor="let validation of validation_messages.query">
                  <span
                    *ngIf="validations_form.get('codelistValueTypeQuery').hasError(validation.type) && (validations_form.get('codelistValueTypeQuery').dirty || validations_form.get('codelistValueTypeQuery').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error> 
            </mat-form-field>
        </div>
         <div class="col-lg-3" *ngIf="(mappingType == 'Codelist Mapping' || mappingType == 'Lookup Mapping') && codelistValueType == 'Constant'"> 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Constant</mat-label>
            <input matInput formControlName="codelistValueTypeConstant" [(ngModel)]="codelistValueTypeConstant" type="text" placeholder="Constant" >
            <mat-error *ngFor="let validation of validation_messages.codelistValueTypeConstant">
              <span
                  *ngIf="validations_form.get('codelistValueTypeConstant').hasError(validation.type) && (validations_form.get('codelistValueTypeConstant').dirty || validations_form.get('codelistValueTypeConstant').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Source Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceSourceObjectsListNames" (click)="searchableReferenceSourceObjects()"
                    formControlName="selectedReferenceSourceObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceSourceObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceSourceObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceSourceObjectsListNamesForm').dirty || validations_form.get('selectedReferenceSourceObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Transform</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceTargetObjectsListNames" (click)="searchableReferenceTargetObjects()"
                    formControlName="selectedReferenceTargetObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceTargetObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceTargetObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceTargetObjectsListNamesForm').dirty || validations_form.get('selectedReferenceTargetObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'"> 
        <mat-form-field appearance="outline" >
          <mat-label i18n="@@TMSTAFFMASTERfirstname">Reference Value Mapping</mat-label>
          <mat-select
                multiple
                matNativeControl
                [(ngModel)]="selectedReferenceValueMapping"
                formControlName="selectedReferenceValueMappingForm"
              >
                <span  *ngFor="let data of codeListData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.mappingTypeName"
                >
                {{ data.mappingTypeName }}
                </mat-option>
                </span>
               
              </mat-select> 
            <!-- <input matInput formControlName="selectedReferenceValueMappingForm" [(ngModel)]="selectedReferenceValueMappingForm" type="text" placeholder="Codelist Name" > -->
            <mat-error *ngFor="let validation of validation_messages.selectedReferenceValueMappingForm">
              <span
                  *ngIf="validations_form.get('selectedReferenceValueMappingForm').hasError(validation.type) && (validations_form.get('selectedReferenceValueMappingForm').dirty || validations_form.get('selectedReferenceValueMappingForm').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
        </mat-form-field>
          </div>
           <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Library Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceLibraryObjectsListNames" (click)="searchableReferenceLibraryObjects()"
                    formControlName="selectedReferenceLibraryForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceLibraryForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceLibraryForm').hasError(validation.type) && (validations_form.get('selectedReferenceLibraryForm').dirty || validations_form.get('selectedReferenceLibraryForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Global Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceGlobalObjectsListNames" (click)="searchableReferenceGlobalObjects()"
                    formControlName="selectedReferenceGlobalObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceGlobalObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceGlobalObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceGlobalObjectsListNamesForm').dirty || validations_form.get('selectedReferenceGlobalObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
               <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference Global Source Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedReferenceGlobalSourceObjectsListNames" (click)="searchableReferenceGlobalSourceObjects()"
                    formControlName="selectedReferenceGlobalSourceObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedReferenceGlobalSourceObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').dirty || validations_form.get('selectedReferenceGlobalSourceObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Global External Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedGlobalExternalObjectsListNames" (click)="searchableGlobalExternalObjects()"
                    formControlName="selectedGlobalExternalObjectsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedGlobalExternalObjectsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedGlobalExternalObjectsListNamesForm').hasError(validation.type) && (validations_form.get('selectedGlobalExternalObjectsListNamesForm').dirty || validations_form.get('selectedGlobalExternalObjectsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div> 
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference DB Object Name</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedRefDBObjectNameListNames" (click)="searchableTargetObjectsForRefDBObjectName()"
                    formControlName="selectedRefDBObjectNameListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedRefDBObjectNameListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedRefDBObjectNameListNamesForm').hasError(validation.type) && (validations_form.get('selectedRefDBObjectNameListNamesForm').dirty || validations_form.get('selectedRefDBObjectNameListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>  
              <div class="col-lg-3" *ngIf="mappingType == 'Functional Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Reference DB Object Fetch Partials</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedRefDBObjectNameFetchPartialsListNames" (click)="searchableTargetObjectsForRefDBObjectNameFetchPartials()"
                    formControlName="selectedRefDBObjectNameFetchPartialsListNamesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectedRefDBObjectNameFetchPartialsListNamesForm">
                      <span
                        *ngIf="validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').hasError(validation.type) && (validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').dirty || validations_form.get('selectedRefDBObjectNameFetchPartialsListNamesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div> 
               <div class="col-lg-3" *ngIf="mappingType == 'Concat Mapping' ">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Query</mat-label>
                            <textarea matInput style="height: 20px;" class="file-path validate" placeholder="Query" formControlName="query" [(ngModel)]="query" (change)="createTransformationQueryConcat()" ></textarea>
                             <mat-error *ngFor="let validation of validation_messages.query">
                              <span
                                *ngIf="validations_form.get('query').hasError(validation.type) && (validations_form.get('query').dirty || validations_form.get('query').touched)">
                                {{ validation.message }}
                              </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
              
        </div>
      <div class="row">
          <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Select Objects</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedStageObjectForMappingType" (click)="searchableObjects()"
                    formControlName="selectStageObjectsForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectStageObjectsForm">
                      <span
                        *ngIf="validations_form.get('selectStageObjectsForm').hasError(validation.type) && (validations_form.get('selectStageObjectsForm').dirty || validations_form.get('selectStageObjectsForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Select Attributes</mat-label>
                  <input matInput type="text"  [(ngModel)]="selectedStageObjectAttributeForMappingType" (click)="searchableAttributes()"
                    formControlName="selectStageObjectsAttributesForm" readonly>
                    <mat-error *ngFor="let validation of validation_messages.selectStageObjectsAttributesForm">
                      <span
                        *ngIf="validations_form.get('selectStageObjectsAttributesForm').hasError(validation.type) && (validations_form.get('selectStageObjectsAttributesForm').dirty || validations_form.get('selectStageObjectsAttributesForm').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
                <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                        <mat-form-field appearance="outline">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Query</mat-label>
                            <textarea matInput style="height: 20px;" class="file-path validate" placeholder="Query" formControlName="query" [(ngModel)]="query" (change)="createTransformationQuery()" ></textarea>
                             <mat-error *ngFor="let validation of validation_messages.query">
                              <span
                                *ngIf="validations_form.get('query').hasError(validation.type) && (validations_form.get('query').dirty || validations_form.get('query').touched)">
                                {{ validation.message }}
                              </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3" *ngIf="mappingType == 'Lookup Mapping'">
                       <!--  -->
                      <div style="width: 15%;text-align: end;">
                  <label (click)="addWhere()" style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;"><em *ngIf="lookupButtonName =='Save'" class="fas fa-plus" style="color:
                      antiquewhite;font-size: large;" title="Add"></em>
                      <em *ngIf="lookupButtonName =='Update'" class="fas fa-refresh" style="color:
                      antiquewhite;font-size: large;" title="Add"></em>
                    </label>
                </div>
                    </div>
            </div>
        <div class="row" *ngIf="mappingType == 'Lookup Mapping' && lookupMultiList.length > 0">
          <div class="col-lg-9 table-responsive">
             <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="lookupColumnDefs"   [animateRows]="true"
              [pagination]="false" [suppressPaginationPanel]="true" [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="false" [debug]="true" [components]="componentsLookup"
              (gridReady)="onGridReadyLookup($event)" [hidden]="!true" style="height: 30vh;margin-bottom: 3%;">
          </ag-grid-angular>
          </div>
        </div>
         <div class="row topRowMargins" style="margin-bottom: 0;margin-top: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Business logic  <span style="font-weight: normal; font-size: medium; color: gray;">(optional)</span></label
            >
            <button i18n="@@CancelButton"
            type="button" (click)=" generateSQL()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            Generate Sql
          </button>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-lg-2"></div> -->
          <div class="col-lg-12">

            <!-- <textarea rows="5" #freetextEditor></textarea> -->
              <app-code-editor
              [(value)]="freetextDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
          </div>
        </div>
        <div class="row topRowMargins" style="margin-bottom: 0;margin-top: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Transformation Expression</label
            >
            <button i18n="@@CancelButton"
            type="button" (click)="openSqlBuilderPopUpForTransformation()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            sql builder
          </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">

            <!-- <textarea rows="5" #codeEditor></textarea> -->
               <app-code-editor
              [(value)]="expressionDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
          </div>
        </div>
        <div class="row topRowMargins" style="margin-bottom: 0;">
          <div class="col-lg-12">
            <label
              style="
                font-weight: 500;
                font-size: larger;
                border-bottom: 0.01px ridge coral;
                color: black;
              "
              >Exception Expression</label
            >
            <button i18n="@@CancelButton"
            type="button" (click)="openSqlBuilderPopUpForException()"
            class="popup gridColour btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            style="font-size: .85rem; margin-top: 12px;margin-left: 2%;
                min-width: 100px; white-space: nowrap; flex: 1;position: relative; z-index: 10;">
            sql builder
          </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <!-- <textarea rows="5" #codeExceptionEditor></textarea> -->
               <app-code-editor
              [(value)]="exceptionExpressionDetails "
              [objectsDetails]="selectedSourceAttributeList"
              height="200px"
              (valueChange)="onExpressionChange($event)">
            </app-code-editor>
          </div>
        </div>
    </form>

 </div>
<!-- <div style="margin-top: 0px">
      
      <form novalidate [formGroup]="validations_form">
       
      </form>
    </div> -->

     <div  class="row mb-1 topRowMargins" >

        <div class="col-lg text-center" >

            <div style="text-align: end">
                    <button  i18n="@@TargetClear" type="button" (click)="mapAttributes()" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="buttonColor" [disabled]="isViewMode">Update</button>

                    <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="buttonColor" >Cancel</button>        


            </div>
 
        </div>
        
    </div>
    </div>
    